// extracted by mini-css-extract-plugin
export default {"container":"zoom-level-view_container__CwLWc"};